import { render, staticRenderFns } from "./CoTwoAccomodationForm.vue?vue&type=template&id=3b5c63a4&scoped=true&"
import script from "./CoTwoAccomodationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoAccomodationForm.vue?vue&type=script&lang=js&"
import style0 from "./CoTwoAccomodationForm.vue?vue&type=style&index=0&id=3b5c63a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c63a4",
  null
  
)

export default component.exports